import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import URL from 'modules/url'
import * as actions from 'actions'
import * as getInvolved from 'modules/getInvolved'
import assets from 'modules/assets'

import TopWrapper from 'components/Utils/TopWrapper'
import Footer from 'components/Utils/Footer'
import RowThreeBlock from 'components/Utils/RowThreeBlock'
import GetInvolvedRows from 'components/Utils/GetInvolvedRows'
import AlertMini from 'components/Utils/AlertMini'

// TODO: change all this inline to classes

class GetInvolved extends Component {
  constructor(props) {
    super(props)
    this.state = { ...props }
  }
  componentDidMount() {
    let { dispatch } = this.props,
        url = URL(this.props)
    dispatch(actions.token.fetchData(url))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  render() {
    let links
    if (this.state.data) {
      links = getInvolved.links(this.state.data)
    }

    if (this.state && this.state.isFetching) {
      return <main className="get-involved"><Spinner /></main>
    } else {
      return (
        <main className="page fade-in get-involved">
          <AlertMini alertIsMinimized={true} />
          <div className="group0 parallax__group">
            <div className="layer parallax__layer--deep">
              <img src={assets('images/getinvolved-blob.png')}  className="parallax-getinvolved" style={{width: '100%', height: 'auto', position: 'fixed'}} />
            </div>

            <div className="layer parallax__layer--base">
              <GetInvolvedRows data={links} />
              <div className="filler" style={{height: '1px', marginTop: '10vmin'}}></div>
              <Footer />
            </div>
          </div>
        </main>
      )
    }
  }
}
GetInvolved.contextTypes = {
}
GetInvolved.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    data: state.token.data
  }
}

export default connect(mapStateToProps)(GetInvolved)



// WEBPACK FOOTER //
// ./src/components/GetInvolved.js